export default [
    {
        date: 1485415882324,
        row: 11,
        col: 9,
        squares: [
            [2, 2, "#000000"],
            [2, 3, "#000000"],
            [3, 3, "#000000"],
            [3, 2, "#000000"],
            [2, 7, "#000000"],
            [2, 8, "#000000"],
            [3, 8, "#000000"],
            [3, 7, "#000000"],
            [6, 5, "#000000"],
            [5, 3, "#000000"],
            [5, 7, "#000000"],
            [4, 3, "#FFFF00"],
            [5, 4, "#FFFF00"],
            [6, 4, "#FFFF00"],
            [5, 6, "#FFFF00"],
            [6, 6, "#FFFF00"],
            [4, 7, "#FFFF00"],
            [7, 4, "#0000FF"],
            [7, 5, "#0000FF"],
            [7, 6, "#0000FF"],
            [8, 7, "#000000"],
            [7, 7, "#000000"],
            [7, 8, "#000000"],
            [8, 5, "#FF0000"],
            [8, 4, "#FFFF00"],
            [9, 4, "#FFFF00"],
            [9, 5, "#FFFF00"],
            [9, 6, "#FFFF00"],
            [8, 6, "#FFFF00"],
            [9, 7, "#FFFF00"],
            [10, 7, "#FFFF00"],
            [10, 5, "#FFFF00"],
            [10, 1, "#008000"],
            [10, 2, "#008000"],
            [10, 3, "#008000"],
            [11, 1, "#008000"],
            [11, 2, "#008000"],
            [11, 3, "#008000"],
            [11, 4, "#008000"],
            [11, 5, "#008000"],
            [11, 6, "#008000"],
            [11, 7, "#008000"],
            [11, 8, "#008000"],
            [11, 9, "#008000"],
            [10, 8, "#008000"],
            [10, 9, "#008000"],
            [9, 1, "#008000"],
            [7, 1, "#008000"],
            [6, 1, "#008000"],
            [6, 2, "#008000"],
            [6, 3, "#008000"],
            [7, 3, "#008000"],
            [7, 2, "#008000"],
            [8, 1, "#008000"],
            [8, 2, "#008000"],
            [8, 3, "#008000"],
            [9, 3, "#008000"],
            [9, 2, "#008000"],
            [6, 7, "#008000"],
            [6, 8, "#008000"],
            [6, 9, "#008000"],
            [7, 9, "#008000"],
            [8, 9, "#008000"],
            [8, 8, "#008000"],
            [9, 8, "#008000"],
            [5, 1, "#008000"],
            [4, 1, "#00FFFF"],
            [3, 1, "#00FFFF"],
            [2, 1, "#00FFFF"],
            [1, 1, "#00FFFF"],
            [1, 2, "#00FFFF"],
            [4, 2, "#00FFFF"],
            [5, 2, "#008000"],
            [1, 3, "#00FFFF"],
            [1, 4, "#00FFFF"],
            [2, 4, "#00FFFF"],
            [2, 5, "#00FFFF"],
            [2, 6, "#00FFFF"],
            [1, 6, "#00FFFF"],
            [1, 5, "#00FFFF"],
            [1, 7, "#00FFFF"],
            [1, 8, "#00FFFF"],
            [1, 9, "#00FFFF"],
            [2, 9, "#00FFFF"],
            [3, 9, "#00FFFF"],
            [4, 9, "#00FFFF"],
            [5, 9, "#008000"],
            [5, 8, "#008000"],
            [4, 8, "#00FFFF"],
            [9, 9, "#008000"],
        ],
    },
];
